type actionNameCreator = (actionName: string) => string;

// 开发票
const invoiceAction: actionNameCreator = (actionName) => `INVOICE@${actionName}`;
export const InvoiceAction = {
  initDefaultState: invoiceAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: invoiceAction('SET_LOADING_STATUS'),
  setInitStatus: invoiceAction('SET_INIT_STATUS'),
  setOrders: invoiceAction('SET_ORDERS'),
  setInvoiceItems: invoiceAction('SET_INVOICE_ITEMS'),
  updateRemark: invoiceAction('UPDATE_REMARK'),
  updateInvoiceAmount: invoiceAction('UPDATE_INVOICE_AMOUNT'),
};
